import * as React from "react";

function SvgIconPencil(props) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.14.18l1.68 1.68a.58.58 0 010 .84l-.54.54L8.76.72 9.3.18a.58.58 0 01.84 0zM7.898 1.563L2.043 7.418 4.59 9.964l5.855-5.855-2.546-2.546zM1.2 8.28L0 12l3.72-1.2L1.2 8.28z"
			/>
		</svg>
	);
}

export default SvgIconPencil;
